import React, { useState } from 'react';
import ResultItem from './ResultItem';
import { ChevronDown } from 'lucide-react';

const ResultGroup = ({ groupName, results, highlightTerm, onShowDetails, defaultOpen = false, isSampleHighlightingEnabled }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  if (!results || results.length === 0) {
    return null;
  }

  return (
    <div className="rounded-xl overflow-hidden shadow-sm shadow-black/10" style={{ border: '1px solid var(--border-primary)', backgroundColor: 'var(--bg-base)' }}>
      <div 
        className="flex justify-between items-center px-5 py-3 cursor-pointer transition-colors duration-150"
        style={{ backgroundColor: 'var(--bg-elevated)' }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3 className="text-[13px] flex items-center gap-2.5" style={{ color: 'var(--text-primary)' }}>
          <span className="font-semibold">{groupName}</span>
          <span className="text-[11px] tabular-nums" style={{ color: 'var(--text-faint)' }}>
            {results.length} {results.length !== 1 ? 'tests' : 'test'}
          </span>
        </h3>
        <ChevronDown size={15} className={`transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} style={{ color: 'var(--text-faint)' }} />
      </div>
      {isOpen && (
        <div className="w-full">
            <div className="flex flex-col">
              {results.map((result, index) => (
                <ResultItem 
                  key={`${result.link}-${index}`} 
                  result={result} 
                  highlightTerm={highlightTerm}
                  onShowDetails={onShowDetails} 
                  isSampleHighlightingEnabled={isSampleHighlightingEnabled}
                />
              ))}
            </div>
        </div>
      )}
    </div>
  );
};

export default ResultGroup;